module.exports = __webpack_public_path__ + "img/case_template_icon_grey.9d751267.svg";